// Tokens de design compartilhados — fonte única para tamanhos, cantos e
// espaçamentos. Os componentes do antd herdam daqui via ConfigProvider, então
// NÃO sobrescreva altura/raio/padding de Input, Select, Button ou DatePicker
// em styled-components ou inline styles (o `npm run lint:ui` acusa).

export const tokens = {
  colorPrimary: '#13143A',
  // mesma fonte do resto do sistema (assets/global.js); sem isso campos,
  // botões e tabelas do antd saem na fonte do sistema operacional
  fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  colorText: '#1f2937',
  colorTextSecondary: '#64748b',
  colorBorder: '#d9dee7',
  colorTextPlaceholder: '#9aa0a6',
  fontSize: 14,
  // densidade de sistema de uso diário (estilo ADVBOX): controles um pouco mais baixos
  controlHeight: 36,
  controlHeightLG: 40,
  controlHeightSM: 28,
  borderRadius: 8,
  borderRadiusLG: 12,
}

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
}

export const antdTheme = {
  token: tokens,
  components: {
    Form: {
      itemMarginBottom: spacing.md,
      verticalLabelPadding: '0 0 6px',
      labelFontSize: 14,
    },
    Button: {
      fontWeight: 600,
    },
    Drawer: {
      footerPaddingBlock: 12,
      footerPaddingInline: 24,
    },
  },
}

// Larguras padrão de drawers de formulário (limitadas à tela no mobile)
export const drawerWidth = {
  form: 'min(560px, 100vw)',
  narrow: 'min(440px, 100vw)',
}
